export const DESKTOP_BLUR_HEIGHT = 500;
export const MOBILE_BLUR_HEIGHT = 1200;
